import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Psychotest from './pages/Psychotest';
import Exam from './pages/Exam';
import Result from './pages/Result';
import RecruiterDashboard from './pages/RecruiterDashboard';
import QuestionManager from './pages/QuestionManager';
import PsychotestManager from './pages/PsychotestManager';
import './index.css';

const PrivateRoute = ({ children, role }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner"></div></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/dashboard" replace />;
  return children;
};

const CandidateProtection = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const protectedPaths = ['/login', '/register', '/dashboard', '/psychotest', '/exam', '/result'];
    const isProtected = protectedPaths.some((path) => location.pathname === path || location.pathname.startsWith(`${path}/`));

    if (!isProtected) return undefined;

    const blockContextMenu = (event) => {
      event.preventDefault();
    };

    const blockInspectShortcuts = (event) => {
      const key = String(event.key || '').toLowerCase();
      const ctrlOrCmd = event.ctrlKey || event.metaKey;

      if (
        key === 'f12' ||
        (ctrlOrCmd && event.shiftKey && ['i', 'j', 'c'].includes(key)) ||
        (ctrlOrCmd && key === 'u')
      ) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    window.addEventListener('contextmenu', blockContextMenu, true);
    window.addEventListener('keydown', blockInspectShortcuts, true);

    return () => {
      window.removeEventListener('contextmenu', blockContextMenu, true);
      window.removeEventListener('keydown', blockInspectShortcuts, true);
    };
  }, [location.pathname]);

  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <CandidateProtection>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={
              <PrivateRoute role="candidate"><Dashboard /></PrivateRoute>
            } />
            <Route path="/psychotest" element={
              <PrivateRoute role="candidate"><Psychotest /></PrivateRoute>
            } />
            <Route path="/exam/:session_id" element={
              <PrivateRoute role="candidate"><Exam /></PrivateRoute>
            } />
            <Route path="/result/:session_id" element={
              <PrivateRoute role="candidate"><Result /></PrivateRoute>
            } />
            <Route path="/recruiter" element={
              <PrivateRoute role="recruiter"><RecruiterDashboard /></PrivateRoute>
            } />
            <Route path="/admin" element={
              <PrivateRoute role="admin"><RecruiterDashboard /></PrivateRoute>
            } />
            <Route path="/recruiter/questions" element={
              <PrivateRoute role="recruiter"><QuestionManager /></PrivateRoute>
            } />
            <Route path="/recruiter/psychotest" element={
              <PrivateRoute role="recruiter"><PsychotestManager /></PrivateRoute>
            } />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </CandidateProtection>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
